import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1053ad51"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice-calculation" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center justify-end" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye mr-2" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_6 = { class: "mt-6" }
const _hoisted_7 = {
  key: 0,
  class: "bg-white border px-6 py-4 flex items-center justify-center"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "invoice-calculation__content" }
const _hoisted_10 = { class: "invoice-calculation__content grid-block" }
const _hoisted_11 = { class: "invoice-calculation__content grid-block" }
const _hoisted_12 = { class: "invoice-calculation__content grid-block" }
const _hoisted_13 = {
  key: 0,
  class: "invoice-calculation__content grid-block"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Стоимость услуг грузчиков:", -1))
const _hoisted_15 = { class: "invoice-calculation__content mt-5" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Размер скидки: 0 ₸", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loader = _resolveComponent("loader")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, {
        title: `Запись вычисления накладной (ID: ${_ctx.invoice_id})`
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_3, [
        (Boolean(_ctx.state.calculation) && Boolean(_ctx.state.calculation.transcriptId))
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "mr-3",
              target: "_blank",
              to: `/billing/transcripts/${_ctx.state.calculation.transcriptId}`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_button, { class: "primary text small" }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createTextVNode(" Показать транскрипт ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        _createVNode(_component_the_button, {
          class: "second text small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Назад ")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.state.is_loading && !_ctx.state.is_failed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_loader, { class: "primary" })
          ]))
        : (_ctx.state.is_failed)
          ? (_openBlock(), _createBlock(_component_failed_fetch, {
              key: 1,
              loading: _ctx.state.is_loading,
              text: `При получении вычислений по накладной (ID: ${_ctx.invoice_id}) произошла ошибка`,
              onRefresh: _ctx.loadInvoiceCalculation
            }, null, 8, ["loading", "text", "onRefresh"]))
          : (Boolean(_ctx.state.calculation))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", null, "Компания: " + _toDisplayString(_ctx.state.calculation?.company), 1),
                  _createElementVNode("div", null, "Тариф: " + _toDisplayString(_ctx.state.calculation?.tariff), 1),
                  _createElementVNode("div", null, "Номер накладной: " + _toDisplayString(_ctx.state.calculation?.invoiceNumber), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(" Параметры накладной: "),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, "Зона: " + _toDisplayString(_ctx.state.calculation?.zone), 1),
                    _createElementVNode("div", null, "Физический вес: " + _toDisplayString(_ctx.state.calculation?.weight), 1),
                    _createElementVNode("div", null, "Объемный вес: " + _toDisplayString(_ctx.state.calculation?.volumeWeight), 1),
                    _createElementVNode("div", null, " Тип перевозки: " + _toDisplayString(_ctx.state.calculation?.shipmentType || 'Нет данных'), 1),
                    _createElementVNode("div", null, "Направление: " + _toDisplayString(_ctx.state.calculation?.direction || 'Нет данных'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createTextVNode(" Стоимость основных услуг: "),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, "Стоимость доставки: " + _toDisplayString(_ctx.state.calculation?.deliveryCharge) + " ₸", 1),
                    _createElementVNode("div", null, "Сумма за упаковку: " + _toDisplayString(_ctx.state.calculation?.packageCharge) + " ₸", 1),
                    _createElementVNode("div", null, "Сумма за страхование: " + _toDisplayString(_ctx.state.calculation?.insuranceCharge) + " ₸", 1),
                    _createElementVNode("div", null, "Сумма за выгрузку: " + _toDisplayString(_ctx.state.calculation?.unloadCharge) + " ₸", 1),
                    _createElementVNode("div", null, " Стоимость оформления заказа: " + _toDisplayString(_ctx.state.calculation?.orderCharge) + " ₸ ", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createTextVNode(" Стоимость дополнительных услуг: "),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, " Авто: " + _toDisplayString(_ctx.state.calculation?.calculationValues?.additionalServices?.carCost) + " ₸ ", 1),
                    _createElementVNode("div", null, " Кран: " + _toDisplayString(_ctx.state.calculation?.calculationValues?.additionalServices?.craneCost) + " ₸ ", 1),
                    _createElementVNode("div", null, " Паллета: " + _toDisplayString(_ctx.state.calculation?.calculationValues?.additionalServices?.gridCost) + " ₸ ", 1),
                    _createElementVNode("div", null, " Тележка: " + _toDisplayString(_ctx.state.calculation?.calculationValues?.additionalServices
                                    ?.hydraulicTrolleyCost) + " ₸ ", 1),
                    _createElementVNode("div", null, " Грузчики: " + _toDisplayString(_ctx.state.calculation?.calculationValues?.additionalServices?.loaderCost) + " ₸ ", 1),
                    _createElementVNode("div", null, " Манипулятор: " + _toDisplayString(_ctx.state.calculation?.calculationValues?.additionalServices
                                    ?.manipulatorCost) + " ₸ ", 1),
                    _createElementVNode("div", null, " Мягкая упаковка: " + _toDisplayString(_ctx.state.calculation?.calculationValues?.additionalServices
                                    ?.softPackageCost) + " ₸ ", 1)
                  ])
                ]),
                (_ctx.state.calculation?.additionalServiceValues)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createTextVNode(" Стоимость дополнительных услуг: "),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, " Упаковка: " + _toDisplayString(_ctx.state.calculation?.additionalServiceValues?.gridCost), 1),
                        _createElementVNode("div", null, " Мягкая упаковка: " + _toDisplayString(_ctx.state.calculation?.additionalServiceValues?.softPackageCost), 1),
                        _createElementVNode("div", null, " Цена машины: " + _toDisplayString(_ctx.state.calculation?.additionalServiceValues?.carCost), 1),
                        _createElementVNode("div", null, " Цена за кран: " + _toDisplayString(_ctx.state.calculation?.additionalServiceValues?.craneCost), 1),
                        _createElementVNode("div", null, " Цена за манипулятор: " + _toDisplayString(_ctx.state.calculation?.additionalServiceValues?.manipulatorCost), 1),
                        _createElementVNode("div", null, " Стоимость паллеты: " + _toDisplayString(_ctx.state.calculation?.additionalServiceValues?.hydraulicTrolleyCost), 1),
                        _hoisted_14
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", null, " Самовывоз: " + _toDisplayString(_ctx.state.calculation?.calculationValues?.standardParams?.pickupPercent) + " % ", 1),
                  _createElementVNode("div", null, " Самопривоз: " + _toDisplayString(_ctx.state.calculation?.calculationValues?.standardParams
                                ?.selfDeliveryPercent) + " % ", 1),
                  _createElementVNode("div", null, "Сумма платежа к оплате: " + _toDisplayString(_ctx.state.calculation?.finalPaymentAmount) + " ₸", 1)
                ])
              ]))
            : _createCommentVNode("", true)
    ])
  ]))
}